import { render, staticRenderFns } from "./work-situation.vue?vue&type=template&id=737c2ec8&scoped=true&"
import script from "./work-situation.vue?vue&type=script&lang=js&"
export * from "./work-situation.vue?vue&type=script&lang=js&"
import style0 from "./work-situation.vue?vue&type=style&index=0&id=737c2ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "737c2ec8",
  null
  
)

export default component.exports